import { Analytics } from '../../views/ts/components/Analytics';
import { CookiesConsent } from '../../views/twig/components/CookiesConsent';
import { Carousel } from '../../views/ts/components/Carousel';
import { LazyLoader } from '../../views/ts/components/LazyLoader';
import { Header } from '../../views/twig/components/Header';
import { Menu } from '../../views/twig/components/Menu';
(new Analytics()).init();
(new Carousel()).init();
(new LazyLoader()).init();
(new Header()).init();
(new Menu()).init();
// Always at the end
(new CookiesConsent()).init();
